import React from 'react'
import {Col, Row, Panel, FormGroup, FormControl, Button} from 'react-bootstrap'
import DateTime from 'react-datetime'

const ArticlesSearch = (props) => {
  const doSearch = (e) => {
    if (e.key === 'Enter') {
      props.onSearch();
    }
  };

  return (
    <Panel className="article-filter">
      <Row>
        <Col md={4}>
          <FormGroup>
            <FormControl onChange={props.onInputChange}
                         onKeyPress={doSearch}
                         placeholder="Article title keyword"
                         value={props.searchValue}/>
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup>
            <DateTime timeFormat="HH:mm"
                      dateFormat="DD/MM/YYYY"
                      value={props.dateFromValue}
                      onChange={props.onDateFromChange}
                      inputProps={{
                        placeholder: 'Display from'
                      }}/>
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup>
            <DateTime timeFormat="HH:mm"
                      dateFormat="DD/MM/YYYY"
                      value={props.dateToValue}
                      onChange={props.onDateToChange}
                      inputProps={{
                        placeholder: 'Display to'
                      }}/>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <FormGroup>
            <FormControl value={props.statusOrderValue}
                         onChange={props.onStatusOrderChange}
                         componentClass="select">
              <option value="">[Status]</option>
              {
                props.statusList.map(item => <option key={item} value={item}>{item}</option>)
              }
            </FormControl>
          </FormGroup>
        </Col>
        <Col md={6} className="actions">
          <Button className="red-ghost-btn"
                  onClick={props.onSearch}>Search</Button>

          <Button className="grey-ghost-btn"
                  onClick={props.onClear}>Clear search/filters</Button>
        </Col>
      </Row>
    </Panel>
  );
};

export default ArticlesSearch;


// WEBPACK FOOTER //
// ./src/components/admin/news/articles/list/articles-search.jsx